// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Es6Promise = require("es6-promise");
var IsomorphicFetch = require("isomorphic-fetch").default;
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("./common/http.res.js");
var Editor$ReactHooksTemplate = require("./surveys/WysiwygEditor/Editor.res.js");
var Header$ReactHooksTemplate = require("./common/Header.res.js");
var SignUp$ReactHooksTemplate = require("./SignUp.res.js");
var Tickets$ReactHooksTemplate = require("./tickets/Tickets.res.js");
var Insights$ReactHooksTemplate = require("./dashboard/dashboard/Insights.res.js");
var NpsTrend$ReactHooksTemplate = require("./surveys/NpsTrend.res.js");
var Projects$ReactHooksTemplate = require("./surveys/Projects.res.js");
var RoleEdit$ReactHooksTemplate = require("./settings/RoleEdit.res.js");
var RoleList$ReactHooksTemplate = require("./settings/RoleList.res.js");
var UserEdit$ReactHooksTemplate = require("./settings/UserEdit.res.js");
var UserForm$ReactHooksTemplate = require("./settings/UserForm.res.js");
var UserList$ReactHooksTemplate = require("./settings/UserList.res.js");
var AdminView$ReactHooksTemplate = require("./AdminView.res.js");
var Campaigns$ReactHooksTemplate = require("./surveys/Campaigns.res.js");
var Downloads$ReactHooksTemplate = require("./Downloads.res.js");
var Responses$ReactHooksTemplate = require("./Responses.res.js");
var Dashboards$ReactHooksTemplate = require("./dashboard/dashboard/Dashboards.res.js");
var DataFields$ReactHooksTemplate = require("./data_fields/DataFields.res.js");
var ReportList$ReactHooksTemplate = require("./reports/ReportList.res.js");
var ReportView$ReactHooksTemplate = require("./reports/ReportView.res.js");
var RoleCreate$ReactHooksTemplate = require("./settings/RoleCreate.res.js");
var SurveyEdit$ReactHooksTemplate = require("./surveys/SurveyEdit.res.js");
var SurveyPage$ReactHooksTemplate = require("./surveys/SurveyPage.res.js");
var Customer360$ReactHooksTemplate = require("./customer360/Customer360.res.js");
var DailyReport$ReactHooksTemplate = require("./DailyReport.res.js");
var LandingPage$ReactHooksTemplate = require("./LandingPage.res.js");
var SetPassword$ReactHooksTemplate = require("./SetPassword.res.js");
var UserProfile$ReactHooksTemplate = require("./settings/UserProfile.res.js");
var AuthProvider$ReactHooksTemplate = require("./AuthProvider.res.js");
var CampaignList$ReactHooksTemplate = require("./surveys/CampaignList.res.js");
var CategoryEdit$ReactHooksTemplate = require("./CategoryEdit.res.js");
var DownloadList$ReactHooksTemplate = require("./tickets/DownloadList.res.js");
var Organization$ReactHooksTemplate = require("./settings/organization.res.js");
var ReleaseFlags$ReactHooksTemplate = require("./ReleaseFlags.res.js");
var TicketWorker$ReactHooksTemplate = require("./tickets/TicketWorker.res.js");
var AnonymousMode$ReactHooksTemplate = require("./surveys/AnonymousMode.res.js");
var InsightsIndex$ReactHooksTemplate = require("./dashboard/dashboard/InsightsIndex.res.js");
var PasswordReset$ReactHooksTemplate = require("./PasswordReset.res.js");
var ResetPassword$ReactHooksTemplate = require("./ResetPassword.res.js");
var SurveyExpired$ReactHooksTemplate = require("./surveys/SurveyExpired.res.js");
var TicketManager$ReactHooksTemplate = require("./tickets/TicketManager.res.js");
var UserKpiCreate$ReactHooksTemplate = require("./settings/UserKpiCreate.res.js");
var CampaignReport$ReactHooksTemplate = require("./surveys/CampaignReport.res.js");
var FollowUpSurvey$ReactHooksTemplate = require("./surveys/FollowUpSurvey.res.js");
var ForgetPassword$ReactHooksTemplate = require("./ForgetPassword.res.js");
var PermissionTree$ReactHooksTemplate = require("./settings/permissionTree.res.js");
var UserInvitation$ReactHooksTemplate = require("./settings/UserInvitation.res.js");
var DataFieldReport$ReactHooksTemplate = require("./surveys/DataFieldReport.res.js");
var GeneralSettings$ReactHooksTemplate = require("./general_settings/GeneralSettings.res.js");
var QuickSurveyForm$ReactHooksTemplate = require("./surveys/QuickSurveyForm.res.js");
var AgentWiseSummary$ReactHooksTemplate = require("./tickets/AgentWiseSummary.res.js");
var DistributionList$ReactHooksTemplate = require("./surveys/DistributionList.res.js");
var CampaignDashboard$ReactHooksTemplate = require("./surveys/CampaignDashboard.res.js");
var QuickSurveyReport$ReactHooksTemplate = require("./surveys/QuickSurveyReport.res.js");
var ReportAutomailers$ReactHooksTemplate = require("./reports/ReportAutomailers.res.js");
var SubscriptionPlans$ReactHooksTemplate = require("./SubscriptionPlans.res.js");
var TelephonicSurveys$ReactHooksTemplate = require("./surveys/TelephonicSurveys.res.js");
var TicketsHeaderPage$ReactHooksTemplate = require("./tickets/TicketsHeaderPage.res.js");
var UserKpiManagement$ReactHooksTemplate = require("./settings/UserKpiManagement.res.js");
var CampaignReportList$ReactHooksTemplate = require("./surveys/CampaignReportList.res.js");
var ResponseModeReport$ReactHooksTemplate = require("./surveys/ResponseModeReport.res.js");
var SurveyPageNotFound$ReactHooksTemplate = require("./surveys/SurveyPageNotFound.res.js");
var UserUpdatePassword$ReactHooksTemplate = require("./settings/UserUpdatePassword.res.js");
var CurrentOrganization$ReactHooksTemplate = require("./CurrentOrganization.res.js");
var InsightsCorrelation$ReactHooksTemplate = require("./dashboard/dashboard/InsightsCorrelation.res.js");
var RedirectionLogicPage$ReactHooksTemplate = require("./surveys/RedirectionLogicPage.res.js");
var TicketGenerationPage$ReactHooksTemplate = require("./surveys/TicketGenerationPage.res.js");
var TicketStandAloneView$ReactHooksTemplate = require("./tickets/TicketStandAloneView.res.js");
var CampaignDataFieldPage$ReactHooksTemplate = require("./surveys/CampaignDataFieldPage.res.js");
var ImportEnrichmentRules$ReactHooksTemplate = require("./general_settings/ImportEnrichmentRules.res.js");
var EmailVerificationMessage$ReactHooksTemplate = require("./EmailVerificationMessage.res.js");
var CampaignReportDownloadList$ReactHooksTemplate = require("./surveys/CampaignReportDownloadList.res.js");

Es6Promise.polyfill();

var emptyState_permissions = PermissionTree$ReactHooksTemplate.emptyPermission();

var emptyState_releaseFlags = ReleaseFlags$ReactHooksTemplate.emptyFlags();

var emptyState_subscriptionPlans = SubscriptionPlans$ReactHooksTemplate.emptyPlans();

var emptyState_organizationProfile = Organization$ReactHooksTemplate.empty();

var emptyState = {
  permissions: emptyState_permissions,
  releaseFlags: emptyState_releaseFlags,
  subscriptionPlans: emptyState_subscriptionPlans,
  organizationProfile: emptyState_organizationProfile,
  loading: false
};

function fetchPermissions(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/user_permissions", PermissionTree$ReactHooksTemplate.decode);
}

function fetchReleaseFlags(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/release_flags", ReleaseFlags$ReactHooksTemplate.decode);
}

function fetchSubscriptionPlans(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/subscription_plans", SubscriptionPlans$ReactHooksTemplate.decode);
}

function fetchOrganizationProfile(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/organizations/current", (function (param) {
                return Json_decode.field("organization", Organization$ReactHooksTemplate.decode, param);
              }));
}

function Application(props) {
  var match = React.useState(function (param) {
        return emptyState;
      });
  var setState = match[1];
  var state = match[0];
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var match$1 = url.path;
  var authorizationRequired;
  if (match$1) {
    var exit = 0;
    switch (match$1.hd) {
      case "accounts" :
          var match$2 = match$1.tl;
          if (match$2) {
            switch (match$2.hd) {
              case "forget_password" :
                  authorizationRequired = match$2.tl ? true : false;
                  break;
              case "reset_password" :
                  var match$3 = match$2.tl;
                  authorizationRequired = match$3 && !match$3.tl ? false : true;
                  break;
              default:
                authorizationRequired = true;
            }
          } else {
            authorizationRequired = true;
          }
          break;
      case "email_verification_message" :
      case "onboarding" :
      case "set_password" :
          exit = 1;
          break;
      case "signup" :
          authorizationRequired = match$1.tl ? true : false;
          break;
      case "surveys" :
          var match$4 = match$1.tl;
          if (match$4) {
            switch (match$4.hd) {
              case "quick_survey" :
                  authorizationRequired = true;
                  break;
              default:
                authorizationRequired = match$4.tl ? true : false;
            }
          } else {
            authorizationRequired = true;
          }
          break;
      default:
        authorizationRequired = true;
    }
    if (exit === 1) {
      var match$5 = match$1.tl;
      authorizationRequired = match$5 && !match$5.tl ? false : true;
    }
    
  } else {
    authorizationRequired = true;
  }
  React.useEffect((function (param) {
          if (authorizationRequired) {
            Js_promise.then_((function (permissions) {
                    return Promise.resolve(Curry._1(setState, (function (prevState) {
                                      return {
                                              permissions: permissions,
                                              releaseFlags: prevState.releaseFlags,
                                              subscriptionPlans: prevState.subscriptionPlans,
                                              organizationProfile: prevState.organizationProfile,
                                              loading: prevState.loading
                                            };
                                    })));
                  }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/user_permissions", PermissionTree$ReactHooksTemplate.decode));
          }
          Js_promise.then_((function (flags) {
                  return Promise.resolve(Curry._1(setState, (function (prevState) {
                                    return {
                                            permissions: prevState.permissions,
                                            releaseFlags: flags,
                                            subscriptionPlans: prevState.subscriptionPlans,
                                            organizationProfile: prevState.organizationProfile,
                                            loading: prevState.loading
                                          };
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/release_flags", ReleaseFlags$ReactHooksTemplate.decode));
          if (authorizationRequired) {
            Js_promise.then_((function (plans) {
                    return Promise.resolve(Curry._1(setState, (function (prevState) {
                                      return {
                                              permissions: prevState.permissions,
                                              releaseFlags: prevState.releaseFlags,
                                              subscriptionPlans: plans,
                                              organizationProfile: prevState.organizationProfile,
                                              loading: true
                                            };
                                    })));
                  }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/subscription_plans", SubscriptionPlans$ReactHooksTemplate.decode));
          }
          Js_promise.then_((function (organization) {
                  return Promise.resolve(Curry._1(setState, (function (prevState) {
                                    return {
                                            permissions: prevState.permissions,
                                            releaseFlags: prevState.releaseFlags,
                                            subscriptionPlans: prevState.subscriptionPlans,
                                            organizationProfile: organization,
                                            loading: prevState.loading
                                          };
                                  })));
                }), fetchOrganizationProfile());
        }), []);
  var setOrganizationProfile = function (org) {
    Curry._1(setState, (function (state) {
            return {
                    permissions: state.permissions,
                    releaseFlags: state.releaseFlags,
                    subscriptionPlans: state.subscriptionPlans,
                    organizationProfile: org,
                    loading: state.loading
                  };
          }));
  };
  var headerView = function (children, parent) {
    var partial_arg = state.releaseFlags;
    var partial_arg$1 = state.subscriptionPlans;
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx(Header$ReactHooksTemplate.make, {
                        parent: parent,
                        flagEnabled: (function (param) {
                            return ReleaseFlags$ReactHooksTemplate.isEnabled(partial_arg, param);
                          }),
                        featureEnabled: (function (param) {
                            return SubscriptionPlans$ReactHooksTemplate.isEnabled(partial_arg$1, param);
                          })
                      }),
                  JsxRuntime.jsx("div", {
                        children: children,
                        className: "pt-62-px"
                      })
                ]
              });
  };
  var standaloneView = function (children) {
    return JsxRuntime.jsx(JsxRuntime.Fragment, {
                children: Caml_option.some(children)
              });
  };
  var defaultParent = !state.loading || SubscriptionPlans$ReactHooksTemplate.isEnabled(state.subscriptionPlans, "Dashboard") && PermissionTree$ReactHooksTemplate.hasCapability("ShowDashboard", state.permissions) ? "dashboard" : (
      PermissionTree$ReactHooksTemplate.hasCapability("ShowSurvey", state.permissions) || !(PermissionTree$ReactHooksTemplate.hasCapability("ShowReport", state.permissions) && SubscriptionPlans$ReactHooksTemplate.isEnabled(state.subscriptionPlans, "Reports")) ? "surveys" : "reports"
    );
  var home = function (param) {
    if (PermissionTree$ReactHooksTemplate.hasCapability("ShowDashboard", state.permissions) && SubscriptionPlans$ReactHooksTemplate.isEnabled(state.subscriptionPlans, "Dashboard")) {
      return JsxRuntime.jsx(Dashboards$ReactHooksTemplate.make, {
                  search: url.search
                });
    } else if (PermissionTree$ReactHooksTemplate.hasCapability("ShowSurvey", state.permissions)) {
      return JsxRuntime.jsx(Projects$ReactHooksTemplate.make, {
                  urlParams: url.search
                });
    } else if (PermissionTree$ReactHooksTemplate.hasCapability("ManageTickets", state.permissions) && SubscriptionPlans$ReactHooksTemplate.isEnabled(state.subscriptionPlans, "Tickets")) {
      return JsxRuntime.jsx(TicketManager$ReactHooksTemplate.make, {
                  scope: "all",
                  search: url.search
                });
    } else if (PermissionTree$ReactHooksTemplate.hasCapability("ResolveTickets", state.permissions) || PermissionTree$ReactHooksTemplate.hasCapability("ManageTickets", state.permissions)) {
      return JsxRuntime.jsx(TicketWorker$ReactHooksTemplate.make, {
                  status: "all",
                  search: url.search
                });
    } else if (PermissionTree$ReactHooksTemplate.hasCapability("ShowUser", state.permissions)) {
      return JsxRuntime.jsx(UserInvitation$ReactHooksTemplate.make, {
                  search: url.search
                });
    } else if (PermissionTree$ReactHooksTemplate.hasCapability("ShowRole", state.permissions)) {
      return JsxRuntime.jsx(RoleList$ReactHooksTemplate.make, {});
    } else if (PermissionTree$ReactHooksTemplate.hasCapability("EditTextCategories", state.permissions)) {
      return JsxRuntime.jsx(CategoryEdit$ReactHooksTemplate.make, {
                  params: url.search
                });
    } else if (PermissionTree$ReactHooksTemplate.hasCapability("ShowReport", state.permissions) && SubscriptionPlans$ReactHooksTemplate.isEnabled(state.subscriptionPlans, "Reports")) {
      return JsxRuntime.jsx(ReportList$ReactHooksTemplate.make, {
                  search: url.search,
                  subscriptionPlans: state.subscriptionPlans
                });
    } else {
      return JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
  };
  var match$6 = url.path;
  var children;
  if (match$6) {
    switch (match$6.hd) {
      case "accounts" :
          var match$7 = match$6.tl;
          if (match$7) {
            switch (match$7.hd) {
              case "forget_password" :
                  children = match$7.tl ? headerView(home(), defaultParent) : standaloneView(JsxRuntime.jsx(ForgetPassword$ReactHooksTemplate.make, {}));
                  break;
              case "password" :
                  var match$8 = match$7.tl;
                  children = match$8 && match$8.hd === "edit" && !match$8.tl ? standaloneView(JsxRuntime.jsx(PasswordReset$ReactHooksTemplate.make, {
                              url: url.search
                            })) : headerView(home(), defaultParent);
                  break;
              case "reset_password" :
                  var match$9 = match$7.tl;
                  children = match$9 && !match$9.tl ? standaloneView(JsxRuntime.jsx(ResetPassword$ReactHooksTemplate.make, {
                              token: match$9.hd
                            })) : headerView(home(), defaultParent);
                  break;
              default:
                children = headerView(home(), defaultParent);
            }
          } else {
            children = headerView(home(), defaultParent);
          }
          break;
      case "admin" :
          var match$10 = match$6.tl;
          children = match$10 && match$10.hd === "view" && !match$10.tl ? headerView(JsxRuntime.jsx(AdminView$ReactHooksTemplate.make, {}), "admin") : headerView(home(), defaultParent);
          break;
      case "campaign" :
          var match$11 = match$6.tl;
          if (match$11) {
            var campaignId = match$11.hd;
            var match$12 = match$11.tl;
            if (match$12) {
              switch (match$12.hd) {
                case "anonymous_links" :
                    children = match$12.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                content: JsxRuntime.jsx(AnonymousMode$ReactHooksTemplate.make, {
                                      campaignId: campaignId
                                    }),
                                campaignId: campaignId
                              }), "campaigns");
                    break;
                case "campaign_data_fields" :
                    children = match$12.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                content: JsxRuntime.jsx(CampaignDataFieldPage$ReactHooksTemplate.make, {
                                      campaignId: campaignId
                                    }),
                                campaignId: campaignId
                              }), "campaigns");
                    break;
                case "campaign_report" :
                    children = match$12.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                content: JsxRuntime.jsx(CampaignReport$ReactHooksTemplate.make, {
                                      search: url.search,
                                      campaignId: campaignId
                                    }),
                                campaignId: campaignId
                              }), "campaigns");
                    break;
                case "follow_up_survey" :
                    children = match$12.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                content: JsxRuntime.jsx(FollowUpSurvey$ReactHooksTemplate.make, {
                                      campaignId: campaignId
                                    }),
                                campaignId: campaignId
                              }), "campaigns");
                    break;
                case "import_enrichment_rules" :
                    children = match$12.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                content: JsxRuntime.jsx(ImportEnrichmentRules$ReactHooksTemplate.make, {
                                      campaignId: campaignId
                                    }),
                                campaignId: campaignId
                              }), "campaigns");
                    break;
                case "redirection_logics" :
                    children = match$12.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                content: JsxRuntime.jsx(RedirectionLogicPage$ReactHooksTemplate.make, {
                                      campaignId: campaignId
                                    }),
                                campaignId: campaignId
                              }), "campaigns");
                    break;
                case "ticket_generation_logics" :
                    children = match$12.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                content: JsxRuntime.jsx(TicketGenerationPage$ReactHooksTemplate.make, {
                                      campaignId: campaignId
                                    }),
                                campaignId: campaignId
                              }), "campaigns");
                    break;
                default:
                  if (campaignId === "reports") {
                    var match$13 = match$11.tl;
                    if (match$13.tl) {
                      children = headerView(home(), defaultParent);
                    } else {
                      var campaignId$1 = match$13.hd;
                      children = headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                content: JsxRuntime.jsx(CampaignReportList$ReactHooksTemplate.make, {
                                      id: campaignId$1
                                    }),
                                campaignId: campaignId$1
                              }), "campaigns");
                    }
                  } else {
                    var match$14 = match$11.tl;
                    switch (match$14.hd) {
                      case "data_field_reports" :
                          children = match$14.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                      content: JsxRuntime.jsx(DataFieldReport$ReactHooksTemplate.make, {
                                            search: url.search,
                                            campaignId: campaignId
                                          }),
                                      campaignId: campaignId
                                    }), "campaigns");
                          break;
                      case "nps_trend" :
                          children = match$14.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                      content: JsxRuntime.jsx(NpsTrend$ReactHooksTemplate.make, {
                                            search: url.search,
                                            campaignId: campaignId
                                          }),
                                      campaignId: campaignId
                                    }), "campaigns");
                          break;
                      case "response_mode_reports" :
                          children = match$14.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                      content: JsxRuntime.jsx(ResponseModeReport$ReactHooksTemplate.make, {
                                            campaignId: campaignId
                                          }),
                                      campaignId: campaignId
                                    }), "campaigns");
                          break;
                      default:
                        children = headerView(home(), defaultParent);
                    }
                  }
              }
            } else {
              children = headerView(home(), defaultParent);
            }
          } else {
            children = headerView(home(), defaultParent);
          }
          break;
      case "campaigns" :
          var match$15 = match$6.tl;
          if (match$15) {
            var campaignId$2 = match$15.hd;
            var exit$1 = 0;
            switch (campaignId$2) {
              case "all" :
                  if (match$15.tl) {
                    exit$1 = 1;
                  } else {
                    children = headerView(JsxRuntime.jsx(CampaignList$ReactHooksTemplate.make, {
                              search: url.search
                            }), "campaigns");
                  }
                  break;
              case "telephonic_surveys" :
                  if (match$15.tl) {
                    exit$1 = 1;
                  } else {
                    children = headerView(JsxRuntime.jsx(TelephonicSurveys$ReactHooksTemplate.make, {}), "telephonic_surveys");
                  }
                  break;
              default:
                exit$1 = 1;
            }
            if (exit$1 === 1) {
              var match$16 = match$15.tl;
              if (match$16) {
                switch (match$16.hd) {
                  case "dashboard" :
                      children = match$16.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                  content: JsxRuntime.jsx(CampaignDashboard$ReactHooksTemplate.make, {
                                        campaignId: campaignId$2
                                      }),
                                  campaignId: campaignId$2
                                }), "campaigns");
                      break;
                  case "distributions" :
                      children = match$16.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                  content: JsxRuntime.jsx(DistributionList$ReactHooksTemplate.make, {
                                        campaignId: campaignId$2
                                      }),
                                  campaignId: campaignId$2
                                }), "campaigns");
                      break;
                  default:
                    if (campaignId$2 === "report_downloads") {
                      var match$17 = match$15.tl;
                      if (match$17.tl) {
                        children = headerView(home(), defaultParent);
                      } else {
                        var campaignId$3 = match$17.hd;
                        children = headerView(JsxRuntime.jsx(Campaigns$ReactHooksTemplate.make, {
                                  content: JsxRuntime.jsx(CampaignReportDownloadList$ReactHooksTemplate.make, {
                                        id: campaignId$3
                                      }),
                                  campaignId: campaignId$3
                                }), "campaigns");
                      }
                    } else {
                      children = headerView(home(), defaultParent);
                    }
                }
              } else {
                children = headerView(home(), defaultParent);
              }
            }
            
          } else {
            children = headerView(home(), defaultParent);
          }
          break;
      case "category_edit" :
          children = match$6.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(CategoryEdit$ReactHooksTemplate.make, {
                      params: url.search
                    }), "comment_categorization");
          break;
      case "customer360" :
          children = match$6.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Customer360$ReactHooksTemplate.make, {}), "Customer 360");
          break;
      case "daily_report" :
          children = match$6.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(DailyReport$ReactHooksTemplate.make, {
                      params: url.search
                    }), "daily_report");
          break;
      case "dashboard" :
          var match$18 = match$6.tl;
          children = match$18 && !match$18.tl ? headerView(JsxRuntime.jsx(Dashboards$ReactHooksTemplate.make, {
                      dashboardId: Caml_format.int_of_string(match$18.hd),
                      search: url.search
                    }), "dashboard") : headerView(home(), defaultParent);
          break;
      case "data_fields" :
          children = match$6.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(DataFields$ReactHooksTemplate.make, {
                      search: url.search
                    }), "data_fields");
          break;
      case "downloads" :
          children = match$6.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Downloads$ReactHooksTemplate.make, {
                      search: url.search
                    }), "downloads");
          break;
      case "editor" :
          children = match$6.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Editor$ReactHooksTemplate.make, {}), "editor");
          break;
      case "email_verification_message" :
          children = match$6.tl ? headerView(home(), defaultParent) : standaloneView(JsxRuntime.jsx(EmailVerificationMessage$ReactHooksTemplate.make, {
                      search: url.search
                    }));
          break;
      case "general_settings" :
          children = match$6.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(GeneralSettings$ReactHooksTemplate.make, {
                      subMenu: url.hash === "" ? "organization_profile" : url.hash,
                      search: url.search
                    }), "general_settings");
          break;
      case "insights" :
          var match$19 = match$6.tl;
          if (match$19) {
            switch (match$19.hd) {
              case "correlation" :
                  children = match$19.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(InsightsIndex$ReactHooksTemplate.make, {
                              content: JsxRuntime.jsx(InsightsCorrelation$ReactHooksTemplate.make, {})
                            }), "insights");
                  break;
              case "dashboard" :
                  children = match$19.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(InsightsIndex$ReactHooksTemplate.make, {
                              content: JsxRuntime.jsx(Insights$ReactHooksTemplate.make, {})
                            }), "insights");
                  break;
              default:
                children = headerView(home(), defaultParent);
            }
          } else {
            children = headerView(home(), defaultParent);
          }
          break;
      case "onboarding" :
          children = match$6.tl ? headerView(home(), defaultParent) : standaloneView(JsxRuntime.jsx(LandingPage$ReactHooksTemplate.make, {}));
          break;
      case "projects" :
          var match$20 = match$6.tl;
          if (match$20) {
            var projectId = match$20.hd;
            var exit$2 = 0;
            if (projectId === "all" && !match$20.tl) {
              children = headerView(JsxRuntime.jsx(Projects$ReactHooksTemplate.make, {
                        urlParams: url.search
                      }), "surveys");
            } else {
              exit$2 = 1;
            }
            if (exit$2 === 1) {
              var match$21 = match$20.tl;
              if (match$21 && match$21.hd === "surveys") {
                var match$22 = match$21.tl;
                if (match$22 && match$22.hd === "edit") {
                  var match$23 = match$22.tl;
                  if (match$23 && !match$23.tl) {
                    var partial_arg = state.subscriptionPlans;
                    children = headerView(JsxRuntime.jsx(SurveyEdit$ReactHooksTemplate.make, {
                              id: match$23.hd,
                              projectId: Caml_format.int_of_string(projectId),
                              featuresEnabled: (function (param) {
                                  return SubscriptionPlans$ReactHooksTemplate.isEnabled(partial_arg, param);
                                })
                            }), "surveys");
                  } else {
                    children = headerView(home(), defaultParent);
                  }
                } else {
                  children = headerView(home(), defaultParent);
                }
              } else {
                children = headerView(home(), defaultParent);
              }
            }
            
          } else {
            children = headerView(home(), defaultParent);
          }
          break;
      case "quick_survey" :
          var match$24 = match$6.tl;
          children = match$24 && match$24.hd === "report" && !match$24.tl ? headerView(JsxRuntime.jsx(QuickSurveyReport$ReactHooksTemplate.make, {
                      search: url.search
                    }), "quick_survey") : headerView(home(), defaultParent);
          break;
      case "reports" :
          var match$25 = match$6.tl;
          if (match$25) {
            var reportId = match$25.hd;
            children = reportId === "automailer" ? (
                match$25.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(ReportAutomailers$ReactHooksTemplate.make, {}), "reports")
              ) : (
                match$25.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(ReportView$ReactHooksTemplate.make, {
                            search: url.search,
                            reportId: reportId
                          }), "reports")
              );
          } else {
            children = headerView(JsxRuntime.jsx(ReportList$ReactHooksTemplate.make, {
                      search: url.search,
                      subscriptionPlans: state.subscriptionPlans
                    }), "reports");
          }
          break;
      case "responses" :
          children = match$6.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Responses$ReactHooksTemplate.make, {
                      params: url.search
                    }), "responses");
          break;
      case "roles" :
          var match$26 = match$6.tl;
          if (match$26) {
            switch (match$26.hd) {
              case "all" :
                  children = match$26.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(RoleList$ReactHooksTemplate.make, {}), "roles");
                  break;
              case "edit" :
                  var match$27 = match$26.tl;
                  children = match$27 && !match$27.tl ? headerView(JsxRuntime.jsx(RoleEdit$ReactHooksTemplate.make, {
                              id: match$27.hd
                            }), "roles") : headerView(home(), defaultParent);
                  break;
              case "new" :
                  children = match$26.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(RoleCreate$ReactHooksTemplate.make, {}), "roles");
                  break;
              default:
                children = headerView(home(), defaultParent);
            }
          } else {
            children = headerView(home(), defaultParent);
          }
          break;
      case "set_password" :
          var match$28 = match$6.tl;
          children = match$28 && !match$28.tl ? standaloneView(JsxRuntime.jsx(SetPassword$ReactHooksTemplate.make, {
                      uuid: match$28.hd
                    })) : headerView(home(), defaultParent);
          break;
      case "signup" :
          children = match$6.tl ? headerView(home(), defaultParent) : standaloneView(JsxRuntime.jsx(SignUp$ReactHooksTemplate.make, {}));
          break;
      case "surveys" :
          var match$29 = match$6.tl;
          if (match$29) {
            var id = match$29.hd;
            switch (id) {
              case "404" :
                  children = match$29.tl ? headerView(home(), defaultParent) : standaloneView(JsxRuntime.jsx(SurveyPageNotFound$ReactHooksTemplate.make, {}));
                  break;
              case "410" :
                  children = match$29.tl ? headerView(home(), defaultParent) : standaloneView(JsxRuntime.jsx(SurveyExpired$ReactHooksTemplate.make, {}));
                  break;
              case "quick_survey" :
                  children = match$29.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(QuickSurveyForm$ReactHooksTemplate.make, {}), "quick_survey");
                  break;
              default:
                children = match$29.tl ? headerView(home(), defaultParent) : standaloneView(JsxRuntime.jsx(SurveyPage$ReactHooksTemplate.make, {
                            id: id
                          }));
            }
          } else {
            children = headerView(home(), defaultParent);
          }
          break;
      case "tickets" :
          var match$30 = match$6.tl;
          if (match$30) {
            switch (match$30.hd) {
              case "agent_summary" :
                  children = match$30.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Tickets$ReactHooksTemplate.make, {
                              content: JsxRuntime.jsx(AgentWiseSummary$ReactHooksTemplate.make, {})
                            }), "tickets");
                  break;
              case "downloadList" :
                  children = match$30.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Tickets$ReactHooksTemplate.make, {
                              content: JsxRuntime.jsx(DownloadList$ReactHooksTemplate.make, {})
                            }), "tickets");
                  break;
              case "manage" :
                  var match$31 = match$30.tl;
                  children = match$31 && !match$31.tl ? headerView(JsxRuntime.jsx(Tickets$ReactHooksTemplate.make, {
                              content: JsxRuntime.jsx(TicketManager$ReactHooksTemplate.make, {
                                    scope: match$31.hd,
                                    search: url.search
                                  })
                            }), "tickets") : headerView(home(), defaultParent);
                  break;
              case "show" :
                  var match$32 = match$30.tl;
                  children = match$32 && !match$32.tl ? headerView(JsxRuntime.jsx(TicketStandAloneView$ReactHooksTemplate.make, {
                              id: match$32.hd
                            }), "tickets") : headerView(home(), defaultParent);
                  break;
              case "tickets_headers" :
                  children = match$30.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(Tickets$ReactHooksTemplate.make, {
                              content: JsxRuntime.jsx(TicketsHeaderPage$ReactHooksTemplate.make, {})
                            }), "tickets");
                  break;
              case "work" :
                  var match$33 = match$30.tl;
                  children = match$33 && !match$33.tl ? headerView(JsxRuntime.jsx(Tickets$ReactHooksTemplate.make, {
                              content: JsxRuntime.jsx(TicketWorker$ReactHooksTemplate.make, {
                                    status: match$33.hd,
                                    search: url.search
                                  })
                            }), "tickets") : headerView(home(), defaultParent);
                  break;
              default:
                children = headerView(home(), defaultParent);
            }
          } else {
            children = headerView(home(), defaultParent);
          }
          break;
      case "users" :
          var match$34 = match$6.tl;
          if (match$34) {
            switch (match$34.hd) {
              case "all" :
                  children = match$34.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(UserList$ReactHooksTemplate.make, {
                              search: url.search
                            }), "users");
                  break;
              case "edit" :
                  var match$35 = match$34.tl;
                  children = match$35 && !match$35.tl ? headerView(JsxRuntime.jsx(UserEdit$ReactHooksTemplate.make, {
                              id: match$35.hd
                            }), "users") : headerView(home(), defaultParent);
                  break;
              case "invite" :
                  children = match$34.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(UserInvitation$ReactHooksTemplate.make, {
                              search: url.search
                            }), "users");
                  break;
              case "kpi" :
                  var match$36 = match$34.tl;
                  children = match$36 ? (
                      match$36.hd === "new" && !match$36.tl ? headerView(JsxRuntime.jsx(UserKpiCreate$ReactHooksTemplate.make, {}), "users") : headerView(home(), defaultParent)
                    ) : headerView(JsxRuntime.jsx(UserKpiManagement$ReactHooksTemplate.make, {
                              search: url.search
                            }), "users");
                  break;
              case "new" :
                  children = match$34.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(UserForm$ReactHooksTemplate.make, {}), "users");
                  break;
              case "profile" :
                  children = match$34.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(UserProfile$ReactHooksTemplate.make, {}), "users");
                  break;
              case "update_password" :
                  children = match$34.tl ? headerView(home(), defaultParent) : headerView(JsxRuntime.jsx(UserUpdatePassword$ReactHooksTemplate.make, {}), "users");
                  break;
              default:
                children = headerView(home(), defaultParent);
            }
          } else {
            children = headerView(home(), defaultParent);
          }
          break;
      default:
        children = headerView(home(), defaultParent);
    }
  } else {
    children = headerView(home(), defaultParent);
  }
  var partial_arg$1 = state.permissions;
  var match$37 = state.permissions;
  var match$38 = url.path;
  var tmp;
  if (match$37) {
    tmp = JsxRuntime.jsx(CurrentOrganization$ReactHooksTemplate.Provider.make, {
          value: [
            state.organizationProfile,
            setOrganizationProfile
          ],
          children: JsxRuntime.jsx("div", {
                children: children,
                className: "font-inter h-full"
              })
        });
  } else if (match$38) {
    switch (match$38.hd) {
      case "accounts" :
          var match$39 = match$38.tl;
          if (match$39) {
            switch (match$39.hd) {
              case "forget_password" :
                  tmp = match$39.tl ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : standaloneView(JsxRuntime.jsx(ForgetPassword$ReactHooksTemplate.make, {}));
                  break;
              case "password" :
                  var match$40 = match$39.tl;
                  tmp = match$40 && !(match$40.hd === "edit" && !match$40.tl) ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : standaloneView(JsxRuntime.jsx(PasswordReset$ReactHooksTemplate.make, {
                              url: url.search
                            }));
                  break;
              case "reset_password" :
                  var match$41 = match$39.tl;
                  tmp = match$41 && !match$41.tl ? standaloneView(JsxRuntime.jsx(ResetPassword$ReactHooksTemplate.make, {
                              token: match$41.hd
                            })) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
                  break;
              default:
                tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
            }
          } else {
            tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
          }
          break;
      case "email_verification_message" :
          tmp = match$38.tl ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : standaloneView(JsxRuntime.jsx(EmailVerificationMessage$ReactHooksTemplate.make, {
                      search: url.search
                    }));
          break;
      case "onboarding" :
          tmp = match$38.tl ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : standaloneView(JsxRuntime.jsx(LandingPage$ReactHooksTemplate.make, {}));
          break;
      case "set_password" :
          var match$42 = match$38.tl;
          tmp = match$42 && !match$42.tl ? standaloneView(JsxRuntime.jsx(SetPassword$ReactHooksTemplate.make, {
                      uuid: match$42.hd
                    })) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
          break;
      case "signup" :
          tmp = match$38.tl ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : standaloneView(JsxRuntime.jsx(SignUp$ReactHooksTemplate.make, {}));
          break;
      case "surveys" :
          var match$43 = match$38.tl;
          if (match$43) {
            var id$1 = match$43.hd;
            switch (id$1) {
              case "404" :
                  tmp = match$43.tl ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : standaloneView(JsxRuntime.jsx(SurveyPageNotFound$ReactHooksTemplate.make, {}));
                  break;
              case "410" :
                  tmp = match$43.tl ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : standaloneView(JsxRuntime.jsx(SurveyExpired$ReactHooksTemplate.make, {}));
                  break;
              default:
                tmp = match$43.tl ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : standaloneView(JsxRuntime.jsx(SurveyPage$ReactHooksTemplate.make, {
                            id: id$1
                          }));
            }
          } else {
            tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
          }
          break;
      default:
        tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsx(AuthProvider$ReactHooksTemplate.make, {
              value: [
                (function (param) {
                    return PermissionTree$ReactHooksTemplate.hasCapability(param, partial_arg$1);
                  }),
                state.permissions
              ],
              children: tmp
            });
}

var make = Application;

exports.emptyState = emptyState;
exports.fetchPermissions = fetchPermissions;
exports.fetchReleaseFlags = fetchReleaseFlags;
exports.fetchSubscriptionPlans = fetchSubscriptionPlans;
exports.fetchOrganizationProfile = fetchOrganizationProfile;
exports.make = make;
/*  Not a pure module */
